import { inrFull } from "../../lib/format";
import { Input } from "../ui/input";
import { n, Match } from "./DetailList";

export const closureError = (c, m) => {
  if (!m) return "Select an MTO";
  if (n(c.closed) + n(c.cancelled) <= 0) return "Enter a closed or cancelled amount.";
  if (Math.round(n(c.closed) + n(c.cancelled)) > Math.round(m.outstanding)) return "Closed + Cancelled amount cannot exceed the original MTO amount.";
  return "";
};

export default function MtoClosing({ answer, setAnswer, mtos, rows, setRows }) {
  const picked = new Set(rows.map((r) => r.mto_id));
  const toggle = (m) => setRows(picked.has(m.id) ? rows.filter((r) => r.mto_id !== m.id) : [...rows, { mto_id: m.id, closed: "", cancelled: "" }]);
  const upd = (id, k, v) => setRows(rows.map((r) => (r.mto_id === id ? { ...r, [k]: v } : r)));
  return (
    <div className="bs-card p-4 space-y-3" data-testid="mto-closing">
      <div className="font-display font-bold text-[#011E38]">ARE YOU CLOSING AN EXISTING MTO TODAY?</div>
      <div className="grid grid-cols-2 gap-2">
        {[["yes", "YES"], ["no", "NO"]].map(([v, l]) => (
          <button key={v} type="button" onClick={() => { setAnswer(v); if (v === "no") setRows([]); }} data-testid={`mto-closing-${v}`}
            className={`h-12 rounded-xl border-2 font-bold transition-colors ${answer === v ? "border-[#011E38] bg-[#011E38] text-white" : "border-slate-200 text-slate-600"}`}>{l}</button>
        ))}
      </div>
      {answer === "yes" && (
        <div className="space-y-2" data-testid="mto-open-list">
          {!mtos.length && <div className="text-sm text-slate-500">You have no outstanding MTOs.</div>}
          {mtos.map((m) => {
            const c = rows.find((r) => r.mto_id === m.id);
            const left = c ? m.outstanding - n(c.closed) - n(c.cancelled) : m.outstanding;
            const err = c && closureError(c, m);
            return (
              <div key={m.id} className={`rounded-xl border p-3 ${c ? "border-[#011E38]" : "border-slate-200"}`} data-testid={`mto-open-${m.mto_ref}`}>
                <label className="flex items-start gap-3 cursor-pointer">
                  <input type="checkbox" checked={!!c} onChange={() => toggle(m)} className="mt-1 w-4 h-4" data-testid={`mto-select-${m.mto_ref}`} />
                  <div className="flex-1 text-sm">
                    <div className="font-semibold text-[#011E38]">{m.mto_ref} — {m.customer_name}</div>
                    <div className="text-xs text-slate-500">Original {inrFull(m.amount)} · Closed {inrFull(m.closed)} · Cancelled {inrFull(m.cancelled)} · <b>Outstanding {inrFull(m.outstanding)}</b></div>
                  </div>
                </label>
                {c && (
                  <div className="mt-3 space-y-2">
                    <div className="grid grid-cols-2 gap-2">
                      <label className="block"><span className="text-xs font-semibold text-slate-600">Closed / Billed (₹)</span>
                        <Input type="number" min="0" value={c.closed} onChange={(e) => upd(m.id, "closed", e.target.value)} className="h-11 mt-1 num" data-testid={`mto-closed-${m.mto_ref}`} /></label>
                      <label className="block"><span className="text-xs font-semibold text-slate-600">Cancelled (₹)</span>
                        <Input type="number" min="0" value={c.cancelled} onChange={(e) => upd(m.id, "cancelled", e.target.value)} className="h-11 mt-1 num" data-testid={`mto-cancelled-${m.mto_ref}`} /></label>
                    </div>
                    <div className="text-sm">Outstanding after this: <b className="num" data-testid={`mto-left-${m.mto_ref}`}>{inrFull(Math.max(left, 0))}</b> · {left <= 0 ? (n(c.closed) > 0 ? "COMPLETED / CLOSED" : "CANCELLED") : "PARTIALLY CLOSED"}</div>
                    {err && <Match ok={false} badText={err} testid={`mto-closure-${m.mto_ref}`} />}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
